<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
      <wt-form-table-list ref="payTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="historyMoney" slot-scope="data">
          <span>{{ $wtUtil.transMoney(data.row.historyMoney) }}</span>
        </template>
        <template slot="residueMoney" slot-scope="data">
          <span>{{ $wtUtil.transMoney(data.row.residueMoney) }}</span>
        </template>
      </wt-form-table-list>
    </wt-form-table>
    <wt-detail-page  :visible.sync="incomeObj.visible" :component-name="form.formComponent.income.componentName" component-type="customer" @on-button-action="onButtonAction" />
    <wt-detail-page  :visible.sync="settleObj.visible" :component-name="form.formComponent.settle.componentName" component-type="customer" @on-button-action="onButtonAction" />
    <el-dialog
      title="现金核销"
      :visible.sync="cash.visible"
      width="30%"
      :modal="false"
      append-to-body
      :close-on-click-modal="false"
      :before-close="handleClose">
      <div>
        <el-form :model="cash.form" ref="cashValidateForm" label-width="100px">
          <el-form-item
            label="支付金额"
            prop="money"
            :rules="[
              { required: true, message: '支付金额不能为空'},
              { pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/, message: '支付金额必须为大于等于0的数字值'}
            ]"
          >
            <el-input type="text" v-model.trim="cash.form.money" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm('cashValidateForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_CUSTOMERPAY',
        formComponent: {
          view: { type: 'component', componentName: 'CustomerInfoView', value: 'queryUserMessageDetailData' },
          add: { type: 'component', componentName: 'UserMessage-edit', value: 'resetUserMessageDetailData' },
          edit: { type: 'component', componentName: 'UserMessage-edit', value: 'queryUserMessageDetailData' },
          list: { type: 'default', value: '/modules/userWechat/userCustomerPayList' },
          delete: { type: 'default', value: '/modules/userMessage/userMessageDelete' },
          income: { componentName: 'CustomerPayIncome' },
          settle: { componentName: 'CustomerPaySettle' }
        },
        formInputsData: [
          { name: '搜索用户', key: 'keyWord', value: '', type: 'text' }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXCEL',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/userWechat/userCustomerPayListImport',
          fileName: '大客户支付',
          permission: 'EXPORT' }],
        formTableData: [
          { name: '账号ID', key: 'id', type: 'text' },
          { name: '大客户名称', key: 'name', type: 'text' },
          { name: '手机号', key: 'phone', type: 'text' },
          { name: '社区', key: 'communityName', type: 'text' },
          { name: '历史总结款', key: 'historyMoney', type: 'custom' },
          { name: '待结款项', key: 'residueMoney', type: 'custom' }],
        formTableButtonsData: [{ name: '现金核销', key: 'CASH', action: 'CASH', hidden: false, className: 'primary', permission: 'CASH' },
          { name: '收入明细', key: 'INCOME', action: 'INCOME', hidden: false, className: 'primary', permission: 'INCOME' },
          { name: '结算明细', key: 'SETTLE', action: 'SETTLE', hidden: false, className: 'primary', permission: 'SETTLE' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonWidth: 320 }
      },
      incomeObj: {
        visible: false
      },
      settleObj: {
        visible: false
      },
      cash: {
        visible: false,
        id: 0,
        form: {
          money: 0
        }
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      console.log('data', data)
      if (data.item.action === 'CASH') {
        this.cash.id = data.row.id
        this.cashDialog()
      }
      if (data.item.action === 'INCOME') {
        this.$store.dispatch('setUserWechatCustomerId', data.row.id)
        this.incomeObj.visible = true
      }
      if (data.item.action === 'SETTLE') {
        this.$store.dispatch('setUserWechatCustomerId', data.row.id)
        this.settleObj.visible = true
      }
    },
    cashDialog() {
      this.cash.form.money = 0
      this.cash.visible = true
    },
    cashConfirmDialog(value) {
      this.$confirm(`您确认为该用户支付 ${value} 元吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log('确定啦')
      }).catch(() => {})
    },
    submitForm(formName) {
      const that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$wtUtil.deleteConfirm(this, `您确认为该用户支付 ${this.cash.form.money} 元吗？`).then(() => {
            request({
              url: '/modules/userWechat/userCustomerPay',
              method: 'post',
              data: {
                id: that.cash.id,
                money: that.cash.form.money * 100
              }
            }).then(res => {
              if (res.code === '0') {
                that.$message({ message: '保存成功', type: 'success' })
                that.$emit('on-dialog-action', 'refresh')
                this.$refs.payTableRef.requestList()
                that.handleClose()
              }
            })
          })
        } else { return false }
      })
    },
    handleClose() {
      this.cash.visible = false
    }
  }
}
</script>
<style scoped>
.table-list-desc {
  padding: 20px;
  color: #333333;
  font-size: 14px;
}
</style>
